import { forwardRef, ForwardRefRenderFunction } from "react";
//#region types
import { CustomerFormContainerProps } from "models/propTypes/customerPropTypes";
import { FormHandles } from "models/propTypes/genericFormProps";
//#endregion
//#region  components
import useCustomerCreateHelpers from "./sections/create/useCustomerCreateHelpers";
import { Skeletons } from "components/common";
import InvoiceSettingsForm from "./invoiceSettingsForm";
//#endregion

const InvoiceSettingsFormContainer: ForwardRefRenderFunction<FormHandles, CustomerFormContainerProps> = (
  props,
  ref
) => {
  const { selectedCustomerChangeHandler, organizationNumberChangeHandler, customer } = props;

  const { handleSubmit, defaultValues, getValidationSchema } = useCustomerCreateHelpers(props);

  return defaultValues ? (
    <InvoiceSettingsForm
      {...props}
      ref={ref}
      getValidationSchema={getValidationSchema}
      defaultValues={defaultValues}
      handleSubmit={handleSubmit}
      organizationNumberChangeHandler={organizationNumberChangeHandler}
      selectedCustomerChangeHandler={selectedCustomerChangeHandler}
      isCreate={false}
      canToggleActiveStatus={customer?.canToggleActiveState}
      customerName={props.customerName}
    />
  ) : (
    <Skeletons.FormSkeleton />
  );
};

export default forwardRef(InvoiceSettingsFormContainer);
